<template>
	<div class="md-grey-page center-horizontal">
<div class="page-banner page-banner--dark-blue"></div>
		<!-- <div v-if="loading">
			<section class="container-white">
				...
			</section>
		</div> -->
		<div v-if="loading" class="margin-top-60 text-center">
			<p class="mdc-theme-primary-dark loading-text">Checking permissions<span>.</span><span>.</span><span>.</span></p>
		</div>

		<div v-if="!loading">
			<section class="container-white" v-if="!success">
				<p class="margin-top-60">Sorry, your activation link is invalid. Please note, activation links are only available once.</p>
			</section>

			<section class="container-white" v-if="success">
				<h3 class="margin-top-30">Thank you for your interest!</h3>
				<p class="margin-top-30">Clicking the button below you are consenting our terms and conditions and you'll activate your access to your client data.</p>
				<p>The API key you'll get will only be available once.</p>
				<button class="mdc-button mdc-button--raised margin-top-30 width-100" @click.prevent="activateKey" :disabled="activating"><span v-if="activating">Generating key...</span><span v-if="!activating">Get API Key</span></button>

				<div class="margin-top-30" v-if="showKey">
					<p>You can now get API access with the following key:</p>
					<span class="api-key">{{apikey}}</span>
					<p class="margin-top-60">Check developer documentation on how to start using BestAgent Rest API: <a href="#">Link</a></p>
				</div>

				<div v-if="showErrorActivating">
					<p class="margin-top-60">Sorry, your activation link is invalid. Please note, activation links are only available once.</p>
				</div>
			</section>
		</div>

	</div>
</template>

<script>
import axios from 'axios';

export default {
  data: function() {
    return {
		 loading: true,
		 success: false,
		 activating: false,
		 showKey: false,
		 showErrorActivating: false,
		 apikey: '',
    }
  },
  created: async function() {
	  const self = this;

	  const params = {
		  companyId: this.$route.params.companyId,
		  access_token: this.$route.params.token,
	  }

	  await axios.post(`${this.config.services.rest}/access_token`, params).then(function(response) {
		  self.success = response.data.success;
		  self.loading = false;
	  }).catch(function(error) {
		  console.error('error:', error);
	  });
  },
  computed: {
  },
  methods: {
	  async activateKey() {
		  const self = this;
		  this.activating = true;

		  const params = {
   		  companyId: this.$route.params.companyId,
   		  access_token: this.$route.params.token,
   	  }

		  await axios.post(`${this.config.services.rest}/activate`, params).then(function(response) {
			  self.activating = false;
			  if(response.data.success) {
				  self.apikey = response.data.apikey;
				  self.showKey = true;
				  self.showErrorActivating = false;
			  } else {
				  self.apikey = '';
				  self.showKey = false;
				  self.showErrorActivating = true;
			  }
   	  }).catch(function(error) {
			  self.activating = false;
   		  console.error('error:', error);
   	  });
	  }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/APIKeys.vue